import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

function getSessionId() {
  const key = "fpb_public_session_id";
  let value = sessionStorage.getItem(key);
  if (!value) {
    value = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    sessionStorage.setItem(key, value);
  }
  return value;
}

export default function PageAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const payload = {
      page_path: location.pathname,
      page_title: document.title,
      referrer: document.referrer || "",
      session_id: getSessionId(),
    };

    fetch(`${API_BASE}/api/analytics/page-view`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  }, [location.pathname]);

  return null;
}
